import React from 'react';
import { notificationDetails } from 'Constants';
import {  DashboardSettingLayout } from 'Layouts';
import { DashboardLayoutWithDescription } from 'Pages/Dashboard/Components/LayoutWithDescription';
import { Content } from './Content';

export const Notifications = () => {

	return (
		<DashboardSettingLayout>
			<DashboardLayoutWithDescription
				content={<Content/>}
				description={notificationDetails}/>
		</DashboardSettingLayout>
	);
};
